import type { HelpRouteKey } from "@/help/helpPlaybook";

export const APURI_HAS_AUTO_OPENED_KEY = "apuri_has_auto_opened";
export const APURI_IS_CLOSED_KEY = "apuri_is_closed";
export const APURI_IS_EXPANDED_KEY = "apuri_is_expanded";

export function readStoredBool(rawValue: string | null, fallback = false): boolean {
  if (rawValue == null) return fallback;
  const normalized = rawValue.trim().toLowerCase();
  if (normalized === "true" || normalized === "1") return true;
  if (normalized === "false" || normalized === "0") return false;
  return fallback;
}

export function toStoredBool(value: boolean): string {
  return value ? "true" : "false";
}

export function shouldAutoOpenApuri(params: {
  routeKey: HelpRouteKey;
  hasCheckedInLifecycle: boolean;
  hasAutoOpened: boolean;
  isClosed: boolean;
}): boolean {
  if (params.hasCheckedInLifecycle) return false;
  if (params.routeKey !== "landing") return false;
  if (params.hasAutoOpened) return false;
  if (params.isClosed) return false;
  return true;
}

